<div *ngIf="_gearAppService.GearMonitorLiterals && _gearAppService.GearMonitorLiterals">
  <h4 class="page-title">
    {{ (_type === 1) ? _gearAppService.GearMonitorLiterals.ComparativeHistory : _gearAppService.GearMonitorLiterals.EndpointsHistory}}
  </h4>
  <div class="screen-container">
    <div class="card mb-3">
      <div class="card-block card-body">
        <div class="row">
          <div class="col-12" *ngFor="let item of _groups; let i = index;" [ngClass]="{'col-sm-6': _groups.length > 1}">
            <p class="lead" *ngIf="i === 0 && _groups.length > 1">{{_appService.CoreCommonLiterals.LeftAxis}}</p>
            <p class="lead" *ngIf="i === 1 && _groups.length > 1">{{_appService.CoreCommonLiterals.RightAxis}}</p>
            <div class="row">
              <div class="form-group col-12" [ngClass]="{'col-sm-3': _groups.length === 1}" *ngIf="_variablesList">
                <custom-select [(ngModel)]="item.variable" 
                  [labelText]="_gearAppService.GearCommonLiterals.Variable"
                  [bordered]="true"
                  [name]="'variable' + i"
                  id="variable-{{i}}"
                  #variable{{i}}="ngModel"
                  [(sourceList)]="_variablesList"
                  (select)="getEndpoints(i)"
                  [disabled]=" ! _endpointsFullList"
                  required>
                </custom-select>
              </div>
              <div class="form-group col-12" [ngClass]="{'col-sm-3': _groups.length === 1}" *ngIf="item.endpointList">
                <label>{{_appService?.CoreCommonLiterals?.EndpointsWord}}</label>
                <ss-multiselect-dropdown 
                  [texts]="_multiSelectTexts" 
                  [name]="'endpoint' + i"
                  id="endpoint-{{i}}"
                  #endpoint{{i}}="ngModel"
                  [settings]="_multiSelectSettings" 
                  [options]="item.endpointList"
                  [disabled]="item.variable?.value === null"
                  [(ngModel)]="item.endpoints"
                  required>
                </ss-multiselect-dropdown>
              </div>
              <div class="form-group col-12" [ngClass]="{'col-sm-3': _groups.length === 1}" *ngIf="_groups.length === 1">
                <form-parameter
                  [(parameter)]="dateParam"
                  
                  name="dateTo"
                  id="dateTo"
                ></form-parameter>
              </div>
              <div class="form-group col-12 d-flex align-items-center" [ngClass]="{'col-sm-3': _groups.length === 1}" *ngIf="_groups.length === 1">
                <div class="custom-control custom-checkbox mt-4">
                  <input
                    [(ngModel)]="offLinePeriods"
                    type="checkbox"
                    [name]="'offLinePeriods'"
                    [id]="'offLinePeriods'"
                    class="custom-control-input"/>
                  <label class="custom-control-label" [for]="'offLinePeriods'">
                    {{_appService.CoreCommonLiterals.ShowOfflinePeriods}}
                    <span class="tooltip-text" triggers="click hover" [tooltip]="'Show offline periods for the selected endpoints'">
                      <i class="fas fa-info-circle" style="font-size: 15px;" aria-hidden="true"></i>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group col-6" *ngIf="_groups.length > 1">
            <form-parameter
              [(parameter)]="dateParam"
             
              name="dateTo"
              id="dateTo"
            ></form-parameter>
          </div>
          <div class="form-group col-6 d-flex align-items-center" *ngIf="_groups.length > 1">
            <div class="custom-control custom-checkbox mt-4">
              <input
                [(ngModel)]="offLinePeriods"
                type="checkbox"
                [name]="'offLinePeriods'"
                [id]="'offLinePeriods'"
                class="custom-control-input"/>
              <label class="custom-control-label" [for]="'offLinePeriods'">
                {{_appService.CoreCommonLiterals.ShowOfflinePeriods}}
                <span class="tooltip-text" triggers="click hover" [tooltip]="'Show offline periods for the selected endpoints'">
                  <i class="fas fa-info-circle" style="font-size: 15px;" aria-hidden="true"></i>
                </span>
              </label>
            </div>
          </div>
        </div>
        <div class="alert alert-danger" *ngIf="_errorBackEnd">{{_errorBackEnd}}</div>
        <div class="text-right">
          <button id="history-btn-search" class="btn btn-primary" [disabled]="_searchStatus === 1" (click)="search()">{{_appService.CoreCommonLiterals.ButtonSearch}}</button>
        </div>
      </div>
    </div>

    <div class="card" *ngIf="_searchStatus === 1 || _chartData">
      <div class="text-right pt-2 px-2">
        <button id="history-btn-details" *ngIf="_chartData && _searchStatus !== 1" class="btn btn-sm btn-secondary toggle-tooltip" (click)="toggleTooltips()">
          <span class="d-none d-sm-inline mr-1">{{ (_chartData?.options?.plugins.tooltip.enabled) ? _gearAppService.GearMonitorLiterals.HideDetails : _gearAppService.GearMonitorLiterals.ShowDetails }}</span>
          <i class="fas" [ngClass]="{'fa-eye-slash': _chartData?.options?.plugins.tooltip.enabled, 'fa-eye': !_chartData.options?.plugins.tooltip.enabled}" style="font-size: 15px;" aria-hidden="true"></i>
        </button>
        <button id="history-btn-reset"  *ngIf="_chartData && _searchStatus !== 1" [disabled]="!_zoomed" class="btn btn-sm btn-secondary ml-2" (click)="resetZoom()">
          <span class="d-none d-sm-inline mr-1">{{_appService.CoreCommonLiterals.ResetZoom}}</span>
          <i class="fas fa-search-minus" style="font-size: 15px;"></i>
        </button>
        <div class="position-relative d-inline-flex" dropdown>
          <button id="history-btn-export" dropdownToggle type="button" class="btn btn-sm btn-secondary ml-2">
            <span class="d-none d-sm-inline mr-1">{{this._appService.CoreCommonLiterals.ActionExport}}</span>
            <i class="fa fa-download" style="font-size: 15px;" aria-hidden="true"></i>
          </button>
          <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
            <li role="menuitem" id="history-btn-exportjpg">
              <a id="btn-exportjpg" type="button" class="dropdown-item" (click)="exportJpg()">{{_appService.CoreCommonLiterals.ExportJPG}}</a>
            </li>
            <li role="menuitem" id="history-btn-exportcsv">
              <a id="btn-exportcsv" type="button" class="dropdown-item" (click)="exportCsv()">{{_appService.CoreCommonLiterals.ExportCSV}}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="card-block card-body">
        <div *ngIf="_searchStatus === 1" class="text-center"><i class="fas fa-circle-notch fa-spin fa-2x fa-fw"></i></div>
        <div class="chart-container" [ngClass]="{'no-data': ! _chartData}">
          <canvas id="canvas">{{_chartData}}</canvas>
        </div>
        <div class="row indicators" *ngIf="_calculated.length">
          <div *ngFor="let item of _calculated; let i = index;" class="col-12 col-sm-6">
            <p *ngIf="i === 0 && _groups.length > 1">{{_appService.CoreCommonLiterals.LeftAxis}}</p>
            <p *ngIf="i === 1 && _groups.length > 1">{{_appService.CoreCommonLiterals.RightAxis}}</p>
            <span><strong>{{_appService.CoreCommonLiterals.Minimum}}:</strong> {{decimalSeparator === ',' ? item.values.min.toLocaleString('es-ES') : item.values.min}}</span>
            <span><strong>{{_appService.CoreCommonLiterals.Maximum}}:</strong> {{decimalSeparator === ',' ? item.values.max.toLocaleString('es-ES') : item.values.max}}</span>
            <span><strong>{{_appService.CoreCommonLiterals.Average}}:</strong> {{decimalSeparator === ',' ? item.values.avg.toLocaleString('es-ES') : item.values.avg}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>